import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import type {
  InstallSystemWorkflowTemplateRequest,
  InstallSystemWorkflowTemplateResponse,
  SystemWorkflowTemplate,
  SystemWorkflowTemplateListResponse,
} from '../models/system-workflow-template.model';

@Injectable({ providedIn: 'root' })
export class SystemWorkflowTemplatesApiService {
  private readonly http = inject(HttpClient);

  list({ vertical }: { vertical?: string } = {}): Observable<SystemWorkflowTemplate[]> {
    let params = new HttpParams();
    if (vertical) params = params.set('vertical', vertical);
    return this.http
      .get<SystemWorkflowTemplateListResponse>('/api/system-workflow-templates', { params })
      .pipe(map((res) => res?.items ?? []));
  }

  install(
    id: string,
    payload: InstallSystemWorkflowTemplateRequest
  ): Observable<InstallSystemWorkflowTemplateResponse> {
    return this.http.post<InstallSystemWorkflowTemplateResponse>(
      `/api/system-workflow-templates/${id}/install`,
      payload
    );
  }
}
